import { REQUEST_STATUSES, TAB_STATUSES, VB_MODE } from "@/constants/index.js";
import { getExperienceValues } from "@/utils/experienceUtils";
import { getVisualBuilderMode } from "@/utils/visualBuilder";

import transformExperienceData from "./transformExperienceData.js";
import * as types from "./types.js";
import { ExperienceService, PublicVisualizationService } from "../../../services";
import { updateVisualBuilderData } from "../visualBuilderData/actions";
import { visualBuilderDataSelector } from "../visualBuilderData/selectors";

export const getCurrentExperience = (params, query) => {
  return async (dispatch, getState) => {
    const { propertyId, experienceId, tabStatus } = params;

    dispatch({
      type: types.SET_CURRENT_EXPERIENCE_REQUEST_STATUS,
      payload: { propertyId, experienceId, status: REQUEST_STATUSES.LOADING },
    });

    let payload = {};

    if (tabStatus !== TAB_STATUSES.PUBLIC) {
      const { resp, status, err } = await ExperienceService.getExperience(propertyId, experienceId, query);

      payload = { ...payload, status, err, ...transformExperienceData(resp) };
    } else {
      const { resp, status, err } = await PublicVisualizationService.getPublicExperience(
        propertyId,
        experienceId,
        query,
      );

      payload = { ...payload, status, err, ...transformExperienceData(resp) };
    }

    dispatch({ type: types.GET_CURRENT_EXPERIENCE, payload });

    const { mode } = getVisualBuilderMode(params);
    const { visualBuilderData } = visualBuilderDataSelector(params)(getState());

    if ([TAB_STATUSES.COLLECT, TAB_STATUSES.CUSTOMIZE].includes(tabStatus) && payload.experience) {
      dispatch(updateVisualBuilderData(params, {}, { locked: payload.experience.locked }));
    }

    if (mode === VB_MODE.PUBLIC_VISUALIZATION && visualBuilderData.id) {
      dispatch(updateVisualBuilderData(params, {}, getExperienceValues(payload.experience), true));
    }
  };
};

export const resetCurrentExperience = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_EXPERIENCE,
      payload: {},
    });
  };
};

export const updateExperienceActivityOpened = (propertyId, experience, activity) => {
  return async (dispatch) => {
    try {
      const { resp, status, err } = await ExperienceService.updatePublicExperience(propertyId, experience.id, {
        activity,
      });

      const transformedExperience = transformExperienceData({
        ...experience,
        activity,
      });

      dispatch({
        type: types.UPDATE_EXPERIENCE_ACTIVITY,
        payload: { propertyId, experience: transformedExperience.experience, activity, resp, status, err },
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_EXPERIENCE_ACTIVITY,
        payload: { propertyId, experience, activity, status: REQUEST_STATUSES.ERROR, err },
      });
    }
  };
};
